import { getAccessToken } from '../auth';
import { API_BASE_URL } from '../config';

export const API_BASE = API_BASE_URL;

export const API_HEADERS: Record<string, string> = {
	'Content-Type': 'application/json',
	Accept: 'application/json'
};

export const getApiAuthHeaders = (): Record<string, string> => {
	const token = getAccessToken();
	return {
		...API_HEADERS,
		...(token ? { Authorization: `Bearer ${token}` } : {})
	};
};
